import { Action, createReducer, on } from '@ngrx/store';
import * as DomainActions from '../actions';
import { IDomainAllowlist } from '../../models/domain-allowlist';

export interface DomainAllowlistState {
  items: IDomainAllowlist[];
}

const initialState: DomainAllowlistState = {
  items: [],
};

export const domainAllowlistReducer = createReducer(
  initialState,
  on(DomainActions.DomainAllowlistUiActions.GetDomainAllowlist, (state) => ({
    ...state,
  })),
  on(DomainActions.DomainAllowlistApiActions.getDomainAllowlistSuccess, (state, { payload }) => ({
    ...state,
    items: payload,
  })),
  on(DomainActions.DomainAllowlistApiActions.getDomainAllowlistError, (state) => ({
    ...state,
    items: [],
  })),

  on(DomainActions.DomainAllowlistUiActions.PostDomainAllowlist, (state) => ({
    ...state,
  })),
  on(DomainActions.DomainAllowlistApiActions.postDomainAllowlistSuccess, (state, { payload }) => ({
    ...state,
    // optimistic add (optional). You can also rely on refetch in effects
    items: state.items.concat(payload as unknown as IDomainAllowlist),
  })),
  on(DomainActions.DomainAllowlistApiActions.postDomainAllowlistError, (state) => ({
    ...state,
  })),

  on(DomainActions.DomainAllowlistUiActions.PatchDomainAllowlist, (state) => ({
    ...state,
  })),
  on(DomainActions.DomainAllowlistApiActions.patchDomainAllowlistSuccess, (state, { payload }) => ({
    ...state,
    items: state.items.map((i) => (i.id === payload.id ? { ...i, ...payload } : i)),
  })),
  on(DomainActions.DomainAllowlistApiActions.patchDomainAllowlistError, (state) => ({
    ...state,
  })),

  on(DomainActions.DomainAllowlistUiActions.DeleteDomainAllowlist, (state) => ({
    ...state,
  })),
  on(DomainActions.DomainAllowlistApiActions.deleteDomainAllowlistSuccess, (state, { id }) => ({
    ...state,
    items: state.items.filter((i) => i.id !== id),
  })),
  on(DomainActions.DomainAllowlistApiActions.deleteDomainAllowlistError, (state) => ({
    ...state,
  }))
);

export function DomainAllowlistReducer(state: DomainAllowlistState | undefined, action: Action) {
  return domainAllowlistReducer(state, action);
}
